export enum ModificationStatusEnum {
	ALGORITHMIC, MANUAL,
}
